/*
  Navigation A/B switch.

  Variant B (the custom card drawer) is revealed by the class `nav-v2` on the
  <html> element; without it the default drawer shows. The experiment tool owns
  that class in production — Intelligems variant B only needs:

    document.documentElement.classList.add('nav-v2');

  This file exists so the team can preview either variant without being bucketed
  into the test: add ?nav=b or ?nav=a to any URL. The choice is kept for the rest
  of the browser session, and ?nav=off forgets it. With no override present this
  script changes nothing, so it never fights the experiment tool's assignment.
*/
(() => {
  const CLASS = 'nav-v2';
  const KEY = 'sundae-nav-variant';
  const root = document.documentElement;

  const readStore = () => {
    try {
      return sessionStorage.getItem(KEY);
    } catch (error) {
      return null;
    }
  };

  const writeStore = (value) => {
    try {
      if (value) sessionStorage.setItem(KEY, value);
      else sessionStorage.removeItem(KEY);
    } catch (error) {
      /* private mode or blocked storage: the override just won't persist */
    }
  };

  const apply = (variant) => {
    if (variant === 'b') root.classList.add(CLASS);
    else if (variant === 'a') root.classList.remove(CLASS);
  };

  let param = null;
  try {
    param = new URLSearchParams(window.location.search).get('nav');
  } catch (error) {
    param = null;
  }

  if (param === 'off') {
    writeStore(null);
  } else if (param === 'a' || param === 'b') {
    writeStore(param);
    apply(param);
  } else {
    apply(readStore());
  }

  window.SundaeNav = {
    get() {
      return root.classList.contains(CLASS) ? 'b' : 'a';
    },
    set(variant) {
      writeStore(variant);
      apply(variant);
    },
    clear() {
      writeStore(null);
      root.classList.remove(CLASS);
    },
  };
})();
